import {Activities, BasicInfo, Rewards, SalesTarget} from '@/containers'
import {Breadcrumb, Tab, TabsNavigation} from '@/components/atoms'
import {PageContainer} from '@/components/organisms'
import {PageHeader} from '@/components/molecules'
import {useState} from 'react'

export const StoreName = () => {
  const [tabIndex, setTabIndex] = useState(0)
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: 'Store List',
            },

            {
              href: '',
              label: 'Store Profile Mexico',
            },
          ],
        }}
        id={'sn_bradcrumb'}
      />
      <PageHeader title={'Store Name 3'} />
      {/* TODO tabs should be passed in an array*/}
      <TabsNavigation isDark handleSetActiveTab={newIndex => setTabIndex(newIndex)} activeTabIndex={tabIndex}>
        <Tab label="Overview" />
        <Tab label="Sales Targets" />
        <Tab label="Activities" />
        <Tab label="Rewards" />
      </TabsNavigation>
      {/* 1st tab content below */}
      <PageContainer data-testid="nbas-list-page">
        {tabIndex === 0 && <BasicInfo />}
        {tabIndex === 1 && <SalesTarget />}
        {tabIndex === 2 && <Activities />}
        {tabIndex === 3 && <Rewards />}
      </PageContainer>
    </>
  )
}
